export default __webpack_public_path__ + "app/views/accounts/detail/statements/tab.html";